import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  Box,
  Button,
  Stack,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  useScrollTrigger,
  Slide,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import HomeIcon from "@mui/icons-material/Home";
import InfoIcon from "@mui/icons-material/Info";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import ContactMailIcon from "@mui/icons-material/ContactMail";
import Logo from "../images/logo-removebg.png";
import { Link } from "react-router-dom";

const navLinks = [
  { label: "Home", to: "/", icon: <HomeIcon fontSize="small" /> },
  { label: "About Us", to: "/about", icon: <InfoIcon fontSize="small" /> },
  {
    label: "Services",
    to: "/services",
    icon: <LocalShippingIcon fontSize="small" />,
  },
  {
    label: "Contact Us",
    to: "/contact",
    icon: <ContactMailIcon fontSize="small" />,
  },
];

function HideOnScroll({ children }) {
  const trigger = useScrollTrigger();
  return (
    <Slide appear={false} direction="down" in={!trigger}>
      {children}
    </Slide>
  );
}

export default function Header() {
  const [drawerOpen, setDrawerOpen] = useState(false);

  const handleDrawerToggle = () => {
    setDrawerOpen(!drawerOpen);
  };

  return (
    <>
      <HideOnScroll>
        <AppBar
          position="sticky"
          color="default"
          elevation={3}
          sx={{
            bgcolor: "white",
            py: { xs: 0.5, md: 0.8 },
          }}
        >
          <Toolbar
            sx={{ justifyContent: "space-between", px: { xs: 2, md: 4 } }}
          >
            {/* Logo */}
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Link to="/">
                <img
                  src={Logo}
                  alt="Mangalmurti Transport"
                  style={{
                    height: "3.5rem", // Responsive height
                  }}
                />
              </Link>
            </Box>

            {/* Desktop Nav */}
            <Stack
              direction="row"
              spacing={3}
              sx={{
                display: { xs: "none", md: "flex" },
              }}
            >
              {navLinks.map((item) => (
                <Button
                  key={item.to}
                  component={Link}
                  to={item.to}
                  sx={{
                    color: "#0e2b4a",
                    fontWeight: 600,
                    fontSize: "1rem",
                    textTransform: "none",
                    "&:hover": {
                      color: "#fff",
                      backgroundColor: "#ff5b1f",
                    },
                  }}
                >
                  {item.label}
                </Button>
              ))}
            </Stack>

            {/* Get a Quote Button */}
            <Box sx={{ display: { xs: "none", md: "block" } }}>
              <Button
                variant="contained"
                color="warning"
                sx={{
                  fontWeight: 600,
                  fontSize: "1rem",
                  borderRadius: "0.5rem",
                  px: "1.5rem",
                  py: "0.6rem",
                }}
                component={Link}
                to="/contact"
              >
                GET A QUOTE
              </Button>
            </Box>

            {/* Mobile Menu Icon */}
            <Box sx={{ display: { xs: "block", md: "none" } }}>
              <IconButton onClick={handleDrawerToggle}>
                <MenuIcon sx={{ fontSize: "1.8rem" }} />
              </IconButton>
            </Box>
          </Toolbar>
        </AppBar>
      </HideOnScroll>

      {/* Drawer for Mobile */}
      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={handleDrawerToggle}
        sx={{
          "& .MuiDrawer-paper": {
            width: 260,
            background: "linear-gradient(180deg, #e8e8e8 0%, #173b6c 100%)",
            color: "white",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          },
        }}
      >
        {/* Navigation Links */}
        <Box sx={{ mt: 3 }}>
          <List>
            {navLinks.map((item) => (
              <ListItem
                button
                key={item.to}
                component={Link}
                to={item.to}
                onClick={handleDrawerToggle}
                sx={{
                  px: 3,
                  py: 1.2,
                  "&:hover": {
                    bgcolor: "rgba(255, 91, 31, 0.8)",
                  },
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                  {item.icon}
                  <ListItemText
                    primary={item.label}
                    primaryTypographyProps={{
                      fontWeight: 600,
                      fontSize: "1rem",
                    }}
                  />
                </Box>
              </ListItem>
            ))}
          </List>
        </Box>

        {/* Get a Quote CTA */}
        <Box sx={{ p: 3, borderTop: "1px solid rgba(255,255,255,0.2)" }}>
          <Button
            fullWidth
            variant="contained"
            sx={{
              backgroundColor: "#ff5b1f",
              color: "white",
              fontWeight: 600,
              borderRadius: "0.5rem",
              py: 1.2,
              fontSize: "1rem",
              "&:hover": {
                backgroundColor: "#e64a14",
              },
            }}
            component={Link}
            to="/contact"
            onClick={handleDrawerToggle}
          >
            Get a Quote
          </Button>
        </Box>
      </Drawer>
    </>
  );
}
